<template>
	<span class="info-tooltip" v-bind:class="['info-tooltip--' + theme, {
		'info-tooltip--open' : isVisible,
		'info-tooltip--open-on-hover' : visibleOnHover,
		'info-tooltip--prev-closed' : prevClosed,
		'info-tooltip--above' : above,
		'info-tooltip--below' : !above,
	}]">
		<div class="info-tooltip__tooltip" v-bind:style="{
			transform: 'translateX('+ (-offset) +'%)',
		}">
			<div class="info-tooltip__body">
				<div v-if="title || canClose" class="info-tooltip__header">
					<div class="grid grid--auto grid--b10">
						<div class="grid__item grid__item--grow info-tooltip__title">
							{{title}}
						</div>
						<div v-if="canClose" class="grid__item">
							<span class="fonticon fonticon--close clickable" @click="close"></span>
						</div>
					</div>
				</div>
				<div class="info-tooltip__content">
					<slot></slot>
				</div>
			</div>
		</div>
	</span>
</template>

<script>

export default {
	name: 'InfoTooltip',
	components: {
	},
	data () {
		return {
			isVisible: null,
			prevClosed: null,
		}
	},
	props: {
		title: String,
		offset: {
			type: Number,
			default: 50
		},
		visibleOnLoad: {
			type: Boolean,
			default: false
		},
		visibleOnHover: {
			type: Boolean,
			default: true
		},
		above: {
			type: Boolean,
			default: true
		},
		canClose: {
			type: Boolean,
			default: true
		},
		theme: {
			type: String,
			default: 'dark',
			validator: function (value) {
				return ['dark', 'light'].indexOf(value) !== -1
			}
		}
	},
	computed: {
	},
	created: function()
	{
	},
	mounted: function()
	{
		var self = this;
		self.isVisible = self.visibleOnLoad;
	},
	methods: {
		close(evt)
		{
			var self = this;
			evt.stopPropagation();
			self.isVisible = false;
			self.prevClosed = true;
			self.$emit('close');
		}
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".info-tooltip";
	#{$c}
	{
		position: relative;
		display: none;

		&--open
		{
			display: block;
		}

		&--open-on-hover:not(#{$c}--prev-closed)
		{
			:hover > &
			{
				display: block;
			}
		}

		&:before
		{
			position: absolute;
			left: 50%;
			margin-left: -5px;
			content: "";
			display: block;
			width: 0;
			height: 0;
			border-style: solid;
			border-width: 6px 5px 6px 5px;
			border-color: palette(font) transparent palette(font) transparent;
			z-index: 101;
		}

		&--light:before
		{
			border-top-color: palette(white);
			border-bottom-color: palette(white);
		}

		&--above:before
		{
			top: calc(100% - 20px);
			border-bottom-width: 0;
			margin-bottom: 6px;
		}

		&--below:before
		{
			bottom: calc(100% - 10px);
			border-top-width: 0;
			margin-top: 6px;
		}

		&__tooltip
		{
			position: absolute;
			left: 50%;
			z-index: 100;
			width: 250px;
			font-size: 12px;
			text-align: left;

			#{$c}--above &
			{
				bottom: 100%;
				margin-bottom: -1px;
				padding-bottom: 20px;
			}

			#{$c}--below &
			{
				top: 100%;
				margin-top: -1px;
				padding-top: 10px;
			}
		}

		&__body
		{
			@include extend(block-center);
			@include extend(bgc-pal--font);
			padding: 10px 10px 16px 24px;
			border-radius: 4px;
			box-shadow: rgba(0,0,0,0.25) 0 3px 8px;

			#{$c}--light &
			{
				@include extend(bgc-pal--white);
			}
		}

		&__header
		{
			line-height: 1;
			margin-bottom: 8px
		}

		&__title
		{
			@include extend(font--bold);
			text-transform: uppercase;
			padding-top: 6px;
			line-height: $base-line-height / $base-font-size;
		}

		&__content
		{
			padding-right: 14px;

			#{$c}--light &
			{
				color: palette(grey);
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/molecules/InfoTooltip.vue